import { useMemo } from 'react';
import { Formik, Form } from 'formik';

import { Widget, WidgetBody } from '@@/Widget';

import { TypedPolicy } from '../../../types';
import { useNameValidation } from '../../../validation/useNameValidation';
import { PolicyConfigurationFormSection } from '../../PolicyConfigurationFormSection';
import { PolicyFormFooter } from '../../PolicyFormFooter';

import { VulnerabilityScanningFormFields } from './VulnerabilityScanningFormFields';
import { VulnerabilityScanningFormValues } from './types';
import { useVulnerabilityScanningInitialValues } from './useVulnerabilityScanningInitialValues';
import { createVulnerabilityScanningValidationSchema } from './vulnerabilityScanningValidationSchema';

interface Props {
  onSubmit: (values: VulnerabilityScanningFormValues) => Promise<void>;
  mode: 'create' | 'edit';
  policy?: TypedPolicy;
  templateData?: Record<string, unknown>;
  onBack?: () => void;
  canGoBack?: boolean;
}

export function VulnerabilityScanningPolicyForm({
  onSubmit,
  mode,
  policy,
  templateData,
  onBack,
  canGoBack,
}: Props) {
  const initialValues = useVulnerabilityScanningInitialValues(
    policy,
    templateData
  );
  const originalEnvironmentGroupIds = policy?.EnvironmentGroups || [];
  const nameValidation = useNameValidation(policy?.Id);
  const validationSchema = useMemo(
    () => createVulnerabilityScanningValidationSchema(nameValidation),
    [nameValidation]
  );

  return (
    <Formik<VulnerabilityScanningFormValues>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize={mode === 'edit'}
      validateOnMount
    >
      <Form className="form-horizontal">
        <Widget>
          <WidgetBody>
            {mode === 'create' && (
              <PolicyConfigurationFormSection policyType="vulnerability-scanning-k8s" />
            )}
            <VulnerabilityScanningFormFields />
            {mode === 'edit' && (
              <PolicyFormFooter
                mode={mode}
                policyType="vulnerability-scanning-k8s"
                policyId={policy?.Id ?? null}
                originalEnvironmentGroupIds={originalEnvironmentGroupIds}
              />
            )}
          </WidgetBody>
        </Widget>

        {mode === 'create' && (
          <PolicyFormFooter
            mode={mode}
            policyType="vulnerability-scanning-k8s"
            policyId={policy?.Id ?? null}
            onBack={onBack}
            canGoBack={canGoBack}
          />
        )}
      </Form>
    </Formik>
  );
}
